export function serializeNodeIdToAnswerPathMap(nodeIdToAnswerPathMap) {
    return Array.from(nodeIdToAnswerPathMap.entries());
}
export function deserializeNodeIdToAnswerPathMap(nodeIdToAnswerPath) {
    return new Map(nodeIdToAnswerPath);
}
